export function inferContentType(filename: string) {
  const extension = filename.split('.').pop();
  switch (extension) {
    case 'glb':
      return 'model/gltf-binary';
    case 'gltf':
      return 'model/gltf+json';
    case 'obj':
      return 'model/obj';
    case 'mtl':
      return 'text/plain';
    default:
      return 'application/octet-stream';
  }
}
